import {RouteNameEnum} from "@/v2/enumerate/route";

const featured = [{
	path: "featured",
	name: RouteNameEnum.GLORY_FEATURED,
	meta: {
		permission: 64001,
		breadcrumb: [{
			key: "glory.featured.index",
			value: null
		}]
	},
	component: () => import("@/page/content/glory/featured/index.vue"),
}];

export default featured;
